import IMApp from "./IMApp";


class User {
    uid;
    nickname;
    headurl;
}

export default class IMUsers {

    static users = [];

    static isUserExist(uid) {
        IMUsers.users.forEach(element => {
            if (element.uid == uid) {
                return true;
            }
        });
        return false;
    }

    static addUserInfos(datas) {
        for (let j = 0; j < datas.length; j++) {
            let data = datas[j];
            IMUsers.users[data.uid] = data;
        }
    }

    static addOrUpdateUser(user) {
        IMUsers.users[user.uid] = user;
    }

    static getUserInfo(uid) {
        if (uid == IMApp.user.uid) {
            return IMApp.user;
        }
        return IMUsers.users[uid];
    }

    static getUsersList(uids) {
        if (!uids || uids.length == 0) {
            return [];
        }
        let users = [];
        uids.forEach(element => {
            let u = IMUsers.getUserInfo(element);
            if (u) {
                users.push(u);
            }
        });
        return users;
    }

    static getNames(uids, chatkey) {
        let users = IMUsers.users;
        let names = [];
        if (users != null && users.length > 0) {
            for (let j = 0; j < uids.length; j++) {
                let user = users[uids[j]];
                names.push(IMApp.getShowName(user, chatkey));
            }
        }
        return names;
    }

    static getHeadurl(uids) {
        let users = IMUsers.users;
        let names = [];
        if (users != null) {
            for (let j = 0; j < uids.length; j++) {
                if (uids[j] == IMApp.user.uid) {
                    names.push(IMApp.user.headurl);
                    continue;
                }
                let user = users[uids[j]];
                if (user) {
                    names.push(user.headurl);
                }
            }
        }
        return names;
    }

    static setFriends() {

    }

    static setAliasFriend() {

    }
}